// extracted by mini-css-extract-plugin
export var geoLocation = "mapInfoCardModal-module--geoLocation--bad79";
export var infoContent = "mapInfoCardModal-module--infoContent--3619a";
export var label = "mapInfoCardModal-module--label--905e3";
export var scannedBy = "mapInfoCardModal-module--scannedBy--8facf";
export var scannedDetails = "mapInfoCardModal-module--scannedDetails--3e32a";
export var scannedInner = "mapInfoCardModal-module--scannedInner--179f0";
export var svgWrapper = "mapInfoCardModal-module--svgWrapper--1ad87";